import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { createRoutes } from './routes'
import { setupRouterGuards } from './guards'

// 创建路由实例
let router: any = null

// 异步创建路由实例
export async function createRouterInstance() {
  if (router) {
    return router
  }

  const routes = await createRoutes()
  
  router = createRouter({
    history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
    routes: routes as RouteRecordRaw[],
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    },
  })

  // 设置路由守卫
  setupRouterGuards(router)

  return router
}

// 为了向后兼容，导出一个默认的路由实例
// 注意：这将在应用启动时创建路由
export default router 